export function getSubtotal(price, quantity){

    let intPrice = parseInt(price * 100)
    let intSubtotal = intPrice * parseInt(quantity)

    let subtotal = parseFloat( ((intSubtotal * 100 ) / 100) / 100 ).toFixed(2)
    
    return subtotal

}